import(/* webpackMode: "eager" */ "/workspace/pwa/app/download/android/page.tsx");
